import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col, Form, FormInput, Text } from 'shared/components'

import { getOptionLabel, getOptionValue } from './helpers'

import * as style from './styles'

// Simple options for marketing promotion filter
const marketingOptions = [
  { id: '', name: 'All' },
  { id: 'true', name: 'Yes' },
  { id: 'false', name: 'No' },
];

const BeneficiaryFiltersComponent = ({
  form,
  loadCategories,
  loadSubcategories,
}) => (
  <Form form={form}>
    <Grid>
      <Row css={style.filtersWrapper}>
        <Col xs={12} sm={3}>
          <Row css={style.wrapSearch}>
            <FormInput
              name="search"
              icon="search"
              placeholder="Search by name..."
              css={style.phoneSpace}
              grayBg
            />
            <div css={style.tooltip}>
              <span className="helpIcon">?</span>
              <div className="tooltiptext">
                <span className="tooltiptext--item">
                  For example, to find all active beneficiaries in a specific category:
                  {"active:=true; categories:=SPORTS, General"}
                </span>
              </div>
            </div>
          </Row>
        </Col>
        <Col xs={12} sm={3}>
          <FormInput
            fluid
            isMulti
            cacheOptions
            defaultOptions
            isSearchable={false}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            type="async-select"
            name="subCategories"
            placeholder="Subcategories"
            loadOptions={loadSubcategories}
            css={style.phoneSpace}
            oldInput
          />
        </Col>
        <Col xs={12} sm={3}>
          <FormInput
            fluid
            isMulti
            cacheOptions
            defaultOptions
            isSearchable={false}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            type="async-select"
            name="categories"
            placeholder="Categories"
            loadOptions={loadCategories}
            css={style.phoneSpace}
            oldInput
          />
        </Col>
        <Col xs={12} sm={3}>
          <FormInput
            fluid
            isSearchable={false}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            type="select"
            name="marketingPromotionSelect"
            placeholder="Marketing Promotion"
            css={style.phoneSpace}
            options={marketingOptions}
            oldInput
          />
        </Col>
      </Row>
    </Grid>
  </Form>
)

BeneficiaryFiltersComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
  loadCategories: PropTypes.func.isRequired,
  loadSubcategories: PropTypes.func.isRequired,
}

export default BeneficiaryFiltersComponent
